/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateReportResponse
 */
export interface GenerateReportResponse {
    /**
     * 
     */
    report_s3_key: string;
    /**
     * 
     */
    report_access_url: string;
}

/**
 * Check if a given object implements the GenerateReportResponse interface.
 */
export function instanceOfGenerateReportResponse(value: object): value is GenerateReportResponse {
    if (!('report_s3_key' in value) || value['report_s3_key'] === undefined) return false;
    if (!('report_access_url' in value) || value['report_access_url'] === undefined) return false;
    return true;
}

export function GenerateReportResponseFromJSON(json: any): GenerateReportResponse {
    return GenerateReportResponseFromJSONTyped(json, false);
}

export function GenerateReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'report_s3_key': json['report_s3_key'],
        'report_access_url': json['report_access_url'],
    };
}

export function GenerateReportResponseToJSON(json: any): GenerateReportResponse {
    return GenerateReportResponseToJSONTyped(json, false);
}

export function GenerateReportResponseToJSONTyped(value?: GenerateReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'report_s3_key': value['report_s3_key'],
        'report_access_url': value['report_access_url'],
    };
}

